import React from "react";
import PropTypes from "prop-types";
import { Button, Center, Text, VStack } from "native-base";
import colors from "../../constants/colors";

const CHUNK_ERROR_PATTERN =
  /Loading chunk .* failed|dynamically imported module|ChunkLoadError/i;
const CHUNK_RELOAD_FLAG = "chunk-reload-attempted";

function clearChunkReloadFlag() {
  try {
    window.sessionStorage.removeItem(CHUNK_RELOAD_FLAG);
    return true;
  } catch (sessionStorageUnavailableError) {
    return false;
  }
}

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error) {
    const isChunkError =
      error?.name === "ChunkLoadError" ||
      CHUNK_ERROR_PATTERN.test(error?.message || "");

    if (!isChunkError) {
      return;
    }

    try {
      if (window.sessionStorage.getItem(CHUNK_RELOAD_FLAG)) {
        return;
      }
      window.sessionStorage.setItem(CHUNK_RELOAD_FLAG, "1");
      window.location.reload();
    } catch (sessionStorageUnavailableError) {
      return;
    }
  }

  handleReload = () => {
    clearChunkReloadFlag();
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <Center flex={1} backgroundColor={colors.pageBackground}>
          <VStack space={4} alignItems="center" padding={4}>
            <Text fontSize="md" textAlign="center">
              Ocurrió un problema al cargar la página.
            </Text>
            <Button
              backgroundColor={colors.primary}
              onPress={this.handleReload}>
              Recargar
            </Button>
          </VStack>
        </Center>
      );
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ErrorBoundary;
